import React from "react";
import { checkForOverride, glow, linearGradient } from "../helpers/theme";
import { ReplaceWithDataSource } from "../helpers/variable";
import Icons from "../Icons";
import H1 from "../H1";

export default function IconWithMessage({
	cue,
	cloud,
	baseTheme,
	baseThemeId,
	isPreview,
	mediaLocation,
}) {
	return (
		<>
			<span
				className={`${cue.type}
    ${
			(cue.status === "cued" && isPreview) ||
			cue.status === "onair" ||
			cue.status === "coming" ||
			(cue.status === "cuedoff" && !isPreview) ||
			cue.status === "going"
				? "opacity-100"
				: "opacity-0"
		}
    animated_${cue.animationName}_holder ${
					(cue.status === "cued" && isPreview) ||
					cue.status === "coming" ||
					cue.status === "onair" ||
					(cue.status === "cuedoff" && !isPreview)
						? `animated_${cue.animationName}_animate-in`
						: `animated_${cue.animationName}_animate-out`
				}

    
    
    
`}
			>
				{/* ICON TEXT */}
				<span
					style={{
						fontFamily: baseTheme.h1?.font || baseTheme.font?.family,
						color: checkForOverride(
							baseTheme,
							"icon_with_message",
							cue.preset,
							"h1",
							"colour"
						),
						fontWeight:
							checkForOverride(
								baseTheme,
								"icon_with_message",
								cue.preset,
								"h1",
								"bold"
							) === true
								? "bold"
								: "normal",
						fontStyle:
							checkForOverride(
								baseTheme,
								"icon_with_message",
								cue.preset,
								"h1",
								"italic"
							) === true
								? "italic"
								: "normal",
						textDecoration:
							checkForOverride(
								baseTheme,
								"icon_with_message",
								cue.preset,
								"h1",
								"underline"
							) === true
								? "underline"
								: "none",
						background: checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"background",
							"colour"
						),
						boxShadow: glow(
							baseTheme,
							cue.type,
							cue.preset,
							"background",
							"glowBlur"
						),
						borderTop: `${
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"sides"
							)[0] === "1"
								? baseTheme.border.size
								: 0
						}vw ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"style"
						)} ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"colour"
						)}`,
						borderBottom: `${
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"sides"
							)[1] === "1"
								? baseTheme.border.size
								: 0
						}vw ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"style"
						)} ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"colour"
						)}`,
						borderRight: `${
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"sides"
							)[3] === "1"
								? baseTheme.border.size
								: 0
						}vw ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"style"
						)} ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"colour"
						)}`,
						borderLeft: `${
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"sides"
							)[2] === "1"
								? baseTheme.border.size
								: 0
						}vw ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"style"
						)} ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"colour"
						)}`,
						width: cue.icon === "custom-text" ? "auto" : "7vw",
						height: "auto",
						filter: "brightness(90%)",
					}}
					className={` key_me ${baseThemeId}_${
						cue.type
					}_large_text ${baseThemeId}_large_text large_text 
        animated_${cue.animationName}_large ${
						(cue.status === "cued" && isPreview) ||
						cue.status === "coming" ||
						cue.status === "onair" ||
						(cue.status === "cuedoff" && !isPreview)
							? `animated_${cue.animationName}_large-animate-in`
							: `animated_${cue.animationName}_large-animate-out`
					}

    px-s2
    py-${checkForOverride(
			baseTheme,
			"icon_with_message",
			cue.preset,
			"background",
			"paddingY"
		)}
    text-${checkForOverride(
			baseTheme,
			"icon_with_message",
			cue.preset,
			"h1",
			"size"
		)}
    leading-${checkForOverride(
			baseTheme,
			"icon_with_message",
			cue.preset,
			"h1",
			"leading"
		)}
    rounded-l-${checkForOverride(
			baseTheme,
			"icon_with_message",
			cue.preset,
			"background",
			"rounding"
		)}
    
    
`}
				>
					<span
						className="flex items-center justify-center w-full"
						style={{
							filter: "brightness(100%)",
						}}
					>
						{cue.icon === "custom-text" && (
							<span className="flex justify-center items-center w-full">
								<ReplaceWithDataSource text={cue.customIcon} styled={true} />
							</span>
						)}

						{cue.icon === "custom-image" && (
							<span className="flex justify-center items-center w-full">
								<img
									alt=""
									src={`${mediaLocation}${cloud ? cue.url : cue.customImage}`}
								/>
							</span>
						)}

						{cue.icon !== "custom-text" && cue.icon !== "custom-image" && (
							<svg
								width="100%"
								height="100%"
								viewBox="0 0 126 126"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<Icons icon={cue.icon} />
							</svg>
						)}
					</span>
				</span>
				{/* LARGE TEXT */}
				<span
					style={{
						fontFamily: baseTheme.h1?.font || baseTheme.font?.family,
						color: checkForOverride(
							baseTheme,
							"icon_with_message",
							cue.preset,
							"h1",
							"colour"
						),
						fontWeight:
							checkForOverride(
								baseTheme,
								"icon_with_message",
								cue.preset,
								"h1",
								"bold"
							) === true
								? "bold"
								: "normal",
						fontStyle:
							checkForOverride(
								baseTheme,
								"icon_with_message",
								cue.preset,
								"h1",
								"italic"
							) === true
								? "italic"
								: "normal",
						textDecoration:
							checkForOverride(
								baseTheme,
								"icon_with_message",
								cue.preset,
								"h1",
								"underline"
							) === true
								? "underline"
								: "none",
						background: linearGradient(
							baseTheme,
							cue.type,
							cue.preset,
							"background",
							"colour"
						),
						boxShadow: glow(
							baseTheme,
							cue.type,
							cue.preset,
							"background",
							"glowBlur"
						),
						borderTop: `${
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"sides"
							)[0] === "1"
								? baseTheme.border.size
								: 0
						}vw ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"style"
						)} ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"colour"
						)}`,
						borderBottom: `${
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"sides"
							)[1] === "1"
								? baseTheme.border.size
								: 0
						}vw ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"style"
						)} ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"colour"
						)}`,
						borderRight: `${
							checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"sides"
							)[3] === "1"
								? baseTheme.border.size
								: 0
						}vw ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"style"
						)} ${checkForOverride(
							baseTheme,
							cue.type,
							cue.preset,
							"border",
							"colour"
						)}`,
					}}
					className={` key_me ${baseThemeId}_${
						cue.type
					}_large_text ${baseThemeId}_large_text large_text 
        animated_${cue.animationName}_small ${
						(cue.status === "cued" && isPreview) ||
						cue.status === "coming" ||
						cue.status === "onair" ||
						(cue.status === "cuedoff" && !isPreview)
							? `animated_${cue.animationName}_small-animate-in`
							: `animated_${cue.animationName}_small-animate-out`
					}

    px-${checkForOverride(
			baseTheme,
			"icon_with_message",
			cue.preset,
			"background",
			"paddingX"
		)}
    py-${checkForOverride(
			baseTheme,
			"icon_with_message",
			cue.preset,
			"background",
			"paddingY"
		)}
    text-${checkForOverride(
			baseTheme,
			"icon_with_message",
			cue.preset,
			"h1",
			"size"
		)}
    leading-${checkForOverride(
			baseTheme,
			"icon_with_message",
			cue.preset,
			"h1",
			"leading"
		)}
    rounded-r-${checkForOverride(
			baseTheme,
			"icon_with_message",
			cue.preset,
			"background",
			"rounding"
			)}
    
`}
				>
					<H1
					cue={cue}
					text={cue.body}
					baseTheme={baseTheme}
					baseThemeId={baseThemeId}
				/>
				</span>
			</span>
		</>
	);
}
